import { cn } from '../cn';

export function Spinner({ className, label = 'Carregando' }: { className?: string; label?: string }) {
  return (
    <span role="status" aria-label={label} className={cn('inline-block size-5 animate-spin rounded-full border-2 border-current border-r-transparent', className)} />
  );
}

export function PageLoader() {
  return (
    <div className="flex min-h-40 items-center justify-center text-brand-600">
      <Spinner className="size-8" />
    </div>
  );
}
